import styled, { css } from "styled-components";

export const LocalCssVariablesWrapper = styled.div`
  ${({ theme }) =>
    css`
      --solution-primary-color: ${theme.primaryColor};
      --solution-secondary-color: ${theme.secondaryColor};
      --solution-hover-color: ${theme.hoverColor};
      --solution-highlight-color: ${theme.highlightColor};
      --solution-primary-color-rgb: ${theme.primaryColorRGB};
      --solution-secondary-color-rgb: ${theme.secondaryColorRGB};
      --solution-hover-color-rgb: ${theme.hoverColorRGB};
      --solution-highlight-color-rgb: ${theme.highlightColorRGB};
      ${overrideGlobalStyle}
    `}
`;

const overrideGlobalStyle = `
.switcher-automation__labels {
  top: 2.5px;
}
`;
